/* eslint-disable no-debugger */
import { ActionTree } from 'vuex';
import IWalmartCheckoutLocation from './models/Location';
import IWalmartCheckoutProduct from './models/Product';
import { IWalmartCheckoutState } from './state';
import {
    SET_AFFILATE_URI,
    SET_GOTO_URI,
    SET_LOCATION,
    ADD_PRODUCT,
    REMOVE_PRODCUT,
    MUT_SET_LOCATION,
    SET_PRODUCTS,
} from './types';

const actions: ActionTree<IWalmartCheckoutState, IWalmartCheckoutState> = {
    [SET_AFFILATE_URI]({ state }, uri: string) {
        state.affiliateUri = uri;
    },
    [SET_GOTO_URI]({ state }, uri: string) {
        state.gotoUri = uri;
    },
    [SET_LOCATION]({ commit }, location: IWalmartCheckoutLocation) {
        commit(MUT_SET_LOCATION, location);
    },
    [ADD_PRODUCT]({ state }, product: IWalmartCheckoutProduct) {
        state.products.push(product);
    },
    [REMOVE_PRODCUT]({ state }, product: IWalmartCheckoutProduct) {
        let index = -1;
        for (let i = 0; i < state.products.length; i += 1) {
            if (state.products[i].Id === product.Id) {
                index = i;
                break;
            }
        }
        if (index === -1) return;
        state.products.splice(index, 1);
    },
    [SET_PRODUCTS]({ state }, products: IWalmartCheckoutProduct[]) {
        state.products = products;
    },
};

export default actions;
